import {call, put, select} from "redux-saga/effects";
import {API} from "../../backend/api";
import {LOGIN_USER_REQUEST_SUCCESS, REGISTER_USER_REQUEST_SUCCESS, GET_USER_REQUEST_SUCCESS} from "./reducer";
import { State } from "../../interfaces/State";
import { GET_USERS_REQUEST_SUCCESS } from "../users/actions";

export function* loginUserRequest(action) {
    const {email, password} = action.payload;
    try {
        const response = yield call(API.loginUser, email, password);

        yield put({
            type: LOGIN_USER_REQUEST_SUCCESS,
            payload: response
        });
    } catch (e){
        yield put({
            type: `${action.type}_ERROR`,
            payload: e.message
        });
    }
}

export function* getUser(action) {
    const state : State = yield select();
    try {
        const response = yield call(API.getUser, state.app.token);

        yield put({
            type: GET_USER_REQUEST_SUCCESS,
            payload: response
        });
    } catch (e){
        yield put({
            type: `${action.type}_ERROR`,
            payload: e.message
        });
    }
}




export function* registerCustomer(action){
    const {name, email, password, company} = action.payload;
    try {
        const response = yield call(API.registerUser, name, email, password, company);
        yield put({
            type: REGISTER_USER_REQUEST_SUCCESS,
            payload: response
        });
    } catch (e){
        yield put({
            type: `${action.type}_ERROR`,
            payload: e.message
        });
    }
}


export function* acceptInvite(action){
    const {email, password, inviteCode} = action.payload;
    try {
        const response = yield call(API.acceptInvite, email, password, inviteCode);
        yield put({
            type: REGISTER_USER_REQUEST_SUCCESS,
            payload: response
        });
    } catch (e){
        yield put({
            type: `${action.type}_ERROR`,
            payload: e.message
        });
    }
}